'use strict';

module.exports = {
    closeBrandsAndScroll: function () {
        var $categoryList = $('#categoryList');
        $categoryList.on('show.bs.collapse', '.collapse[id^=href]', function () {
            var $category = $(this).closest('.category-and-line')[0];
            $category.scrollIntoView({ behavior: 'smooth' });

            var $openCategories = $categoryList.find('.collapse.show');
            setTimeout(function () {
                $openCategories.collapse('hide');
            }, 600);
        });
        $categoryList.on('show.bs.collapse', '.collapse [id^=showMore]', function (e) {
            e.stopPropagation();
        });
    },
    getBanner: function () {
        $(document).ready(
            function () {
                var $brandsBanner = $('#brands_banner');
                if ($brandsBanner) {
                    var url = $brandsBanner.data('url');
                    $.ajax({
                        url: url,
                        type: 'get',
                        dataType: 'html',
                        success: function (data) {
                            $brandsBanner.empty();
                            $brandsBanner.html($(data).find('.experience-layouts-brands_banner'));
                        }
                    });
                }
            }
        );
    },
    bannerSeo: function () {
        $('.container').on('click', '.brand-seo-button', function () {
            $(this).parent().toggleClass('brand-seo-closed brand-seo-open');
        });
    }
};
